<template>
  <div class="workpackage-pricing-groups">
    <!-- Pricing groups header - only show in expanded view -->
    <div v-if="!collapsedView" class="d-flex justify-space-between align-center mb-4">
      <div class="pg-title">Pricing groups</div>
    </div>

    <!-- Pricing Group Cards - with horizontal scroll in collapsed view -->
    <div :class="{ 'horizontal-scroll-container': collapsedView }">
      <div
        v-for="(unit, i) in pricingGroups"
        :key="`pricingGroup${i}`"
        :class="{ 'pricing-group-item': collapsedView }"
      >
        <workpackage-pg-item
          :unit="unit"
          :categories="getCategoriesForUnit(unit)"
          :prevent-unit-selection="false"
          :is-selectable="false"
          :collapsed-view="collapsedView"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { get, sortBy } from 'lodash';

export default {
  name: 'WorkpackagePricingGroups',

  props: {
    workpackage: {
      type: Object,
      required: true,
    },
    collapsedView: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      expandedGroups: {},
    };
  },

  computed: {
    pricingGroups() {
      return this.getPricingGroupsFromWorkpackage(this.workpackage);
    },
  },

  methods: {
    getPricingGroupsFromWorkpackage(workpackage) {
      // Filter units that are retail (not wholesale)
      const retailUnits = get(workpackage, 'units', []).filter(unit => unit.wholesale === false);
      // Sort by levelEntryDescription
      return sortBy(retailUnits, 'levelEntryDescription');
    },

    getCategoriesForUnit(unit) {
      // This would fetch actual categories from the API or parent component
      return get(unit, 'categories', []);
    },
  },
};
</script>

<style lang="scss" scoped>
.pg-title {
  color: #343a3f;
  font-size: 1.4rem;
  font-weight: bold;
}

.workpackage-pricing-groups {
  .horizontal-scroll-container {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    border-top: 1px solid #a2a9b0;

    scrollbar-width: thin; /* Firefox */

    &::-webkit-scrollbar {
      height: 4px; /* Chrome/Safari/Edge */
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }
  }

  .pricing-group-item {
    flex: 0 0 auto;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
